import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
import Theme from "@adsk/alloy-react-theme";
export var InputContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: ", "px;\n"], ["\n  padding-bottom: ", "px;\n"])), Theme.spacing.xLarge);
var templateObject_1;
